import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import DatePicker from "react-multi-date-picker";
import { DropdownWithSearch, Dropdown, Image } from "hesus-ui-kit";
import BaseTable from "./components/BaseTable";
import {
  getDatePickerFormat,
  getDateFormat,
  getCalendarLocale,
} from "@utils/datePickerUtils";

import {
  FILTER_TYPE_DROPDOWN,
  FILTER_TYPE_MULTI_SELECT_DROPDOWN,
  FILTER_TYPE_BUTTON,
  FILTER_TYPE_DATEPICKER,
} from "@utils/constants";
import "./EnhancedTable.scss";

const EncloseTable = (props) => {
  const {
    columns,
    data,
    setData,
    extraFilters,
    initialPageSize,
    defaultSortOptions,
    isRefreshDataAgain,
    skipPageReset,
    setSkipPageReset,
    pageCount,
    setPageCount,
    fetchRecords,
    loading,
    type,
    t,
    currentPageToFirst,
    setCurrentPageToFirst,
    createNewAction,
    statusKey,
    statusCheck,
    additionalFilters,
    setAdditionalFilters,
    customAction,
    selectedFilter,
    extraData,
  } = props;

  const [multiSelectFilters, setMultiSelectFilters] = useState(
    selectedFilter?.length > 0 ? selectedFilter : []
  );
  const updateMyData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    setSkipPageReset(true);
    setData((old) =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          };
        }
        return row;
      })
    );
  };

  const updateMultiSelectFilters = (name, filter) => {
    const isFilterPresent = multiSelectFilters.find(
      (additionalFilterItem) => additionalFilterItem.column === name
    );
    if (isFilterPresent) {
      const updatedMultiSelectFilters = multiSelectFilters.map(
        (additionalFilterItem) => {
          const tempFilter = additionalFilterItem;
          if (additionalFilterItem.column === name) {
            tempFilter.value = filter;
          }
          return tempFilter;
        }
      );
      setMultiSelectFilters(updatedMultiSelectFilters);
    } else {
      setMultiSelectFilters([
        ...multiSelectFilters,
        { column: name, value: filter },
      ]);
    }
  };

  const onMultiSelectFilterChange = (name, filter) => {
    // modify label with column name.
    const modifiedFilters = filter.map((additionalFilterItem) => {
      const tempFilter = {};
      tempFilter.column = name;
      tempFilter.value = additionalFilterItem.value;
      return tempFilter;
    });
    // select other additional filters.
    const selectedAdditionalFilters = additionalFilters.filter(
      (additionalFilterItem) => additionalFilterItem.column !== name
    );
    // remove currently changed filter from applied filters list.
    // const selectedAppliedFilters = requestData.appliedFilters.filter(
    //   (additionalFilterItem) => additionalFilterItem.column !== name
    // );

    setAdditionalFilters([...selectedAdditionalFilters, ...modifiedFilters]);
    // setRequestData({ ...requestData, appliedFilters: selectedAppliedFilters });

    // update the multiSelectFilters array.
    updateMultiSelectFilters(name, filter);
  };

  const onFilterChange = (filter) => {
    const isFilterPresent = additionalFilters.find(
      (additionalFilterItem) => additionalFilterItem.column === filter.name
    );
    if (isFilterPresent) {
      const updatedFilters = additionalFilters.map((additionalFilterItem) => {
        const tempFilter = additionalFilterItem;
        if (additionalFilterItem.name === filter.name) {
          tempFilter.value = filter.value;
          tempFilter.column = filter.name;
        }
        return tempFilter;
      });
      setAdditionalFilters(updatedFilters);
    } else {
      setAdditionalFilters([
        ...additionalFilters,
        { column: filter.name, value: filter.value },
      ]);
    }
  };
  // useEffect(() => {
  //   const additionalFiltersData = [];
  //   if (preSelectFilter) {
  //     selectedFilter.map((filters) => {
  //       filters.value.map((filter) => {
  //         additionalFiltersData.push({
  //           column: filters.column,
  //           value: filter.value,
  //         });
  //       });
  //     });
  //     setMultiSelectFilters(selectedFilter);
  //     setAdditionalFilters(additionalFiltersData);
  //     setPreSelectFilter(false);
  //   }
  // }, [preSelectFilter]);

  return (
    <BaseTable
      columns={columns}
      data={data}
      setData={setData}
      updateMyData={updateMyData}
      skipPageReset={skipPageReset}
      manualPagination
      pageCount={parseInt(pageCount, 10)}
      controlledPageCount={parseInt(pageCount, 10)}
      fetchData={fetchRecords}
      initialPageSize={initialPageSize}
      defaultSortOptions={defaultSortOptions}
      loading={loading}
      currentPageToFirst={currentPageToFirst}
      setCurrentPageToFirst={setCurrentPageToFirst}
      type={type}
      canRefresh={isRefreshDataAgain}
      createNewAction={createNewAction}
      customAction={customAction}
      statusKey={statusKey}
      statusCheck={statusCheck}
      extraData={extraData}
      renderExtraFilters={() => {
        return (
          <>
            {extraFilters.map((filterItem) => {
              if (filterItem.type === FILTER_TYPE_DROPDOWN) {
                return (
                  <Dropdown
                    key={filterItem.name}
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...filterItem}
                    value={additionalFilters.find(
                      (additionalFilterItem) =>
                        additionalFilterItem.name === filterItem.name
                    )}
                    onChange={onFilterChange}
                  />
                );
              }
              if (filterItem.type === FILTER_TYPE_MULTI_SELECT_DROPDOWN) {
                return (
                  <DropdownWithSearch
                    key={filterItem.name}
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...filterItem}
                    value={
                      multiSelectFilters.find(
                        (additionalFilterItem) =>
                          additionalFilterItem.column === filterItem.name
                      )?.value
                    }
                    onChange={(value) =>
                      onMultiSelectFilterChange(filterItem.name, value)
                    }
                  />
                );
              }
              if (filterItem.type === FILTER_TYPE_BUTTON) {
                return (
                  <div
                    className="status__filters-wrapper"
                    key={filterItem.name}
                  >
                    {filterItem.status === 1 && (
                      <Image
                        src={filterItem.imageEnableIcon}
                        onClick={() =>
                          filterItem.changeStatus.changeStatus(filterItem.name)
                        }
                      />
                    )}
                    {(filterItem.status === 2 || filterItem.status === 0) && (
                      <Image
                        src={filterItem.imageDisableIcon}
                        onClick={() =>
                          filterItem.changeStatus.changeStatus(filterItem.name)
                        }
                      />
                    )}
                    <label className="label text-black-label">
                      {t(filterItem.label)}
                    </label>
                  </div>
                );
              }
              if (filterItem.type === FILTER_TYPE_DATEPICKER) {
                return (
                  <div
                    className="filter-datepicker-container"
                    key={filterItem.name}
                  >
                    <label
                      htmlFor={filterItem.name}
                      className="filter-datepicker-label"
                    >
                      {t(filterItem.label)}
                    </label>

                    <DatePicker
                      inputClass="filter-date-input"
                      containerClassName="filter-datepicker-container"
                      calendarPosition="bottom-center"
                      //value={filterItem.value[filterItem.name]}
                      //format={filterItem.format}
                      value={
                        getDateFormat(
                          filterItem.value[filterItem.name],
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      onChange={(value) =>
                        filterItem.onDateChange.onDateChange(
                          filterItem.name,
                          value
                        )
                      }
                      format={getDatePickerFormat()}
                      locale={getCalendarLocale()}
                      name={filterItem.name}
                    />
                  </div>
                );
              }
              return null;
            })}
          </>
        );
      }}
    />
  );
};

EncloseTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  type: PropTypes.string.isRequired,
  initialPageSize: PropTypes.number,
  isRefreshDataAgain: PropTypes.bool,
  defaultSortOptions: PropTypes.arrayOf(PropTypes.object),
  extraFilters: PropTypes.arrayOf(PropTypes.object),
  t: PropTypes.func.isRequired,
  createNewAction: PropTypes.func,
  statusKey: PropTypes.string,
  statusCheck: PropTypes.bool,
  customAction: PropTypes.func,
  selectedFilter: PropTypes.arrayOf({}),
  extraData: PropTypes.object,
};

EncloseTable.defaultProps = {
  initialPageSize: 10,
  isRefreshDataAgain: false,
  extraFilters: [],
  defaultSortOptions: [],
  createNewAction: null,
  statusKey: null,
  statusCheck: false,
  customAction: null,
  selectedFilter: {},
  extraData: {},
};

export default withTranslation()(EncloseTable);
